"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarButtonText = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _typography = require("../../typography");
const ToolbarButtonText = (0, _styled.default)(_typography.TypeRampV2)`
    min-width: 0;

    ${_ref => {
  let {
    toolbarSize,
    toolbarButtonType,
    hasIconAfter,
    textAlign
  } = _ref;
  let marginLeft;
  let marginRight;

  // From ToolbarButtonStyle, copied for reference here to help determine the margin value needed for the text.
  // This should all be moved into flex wrappers in the Toolbar Component with Gap settings in the future.
  // Not sure why large was updated for ursa, but not small and medium.
  // small:
  //   padding-left: 4px;
  //   padding-right: 2px;
  // medium:
  //   padding-left: 4px;
  //   padding-right: 2px;
  // large lodestar:
  //   padding-left: 6px;
  //   padding-right: 4px;
  // large ursa:
  //   padding-left: 8px;
  //   padding-right: 8px;
  // leftSplitButtonPadding ursa
  //   padding-left: 8px;
  //   padding-right: 4px;
  // leftSplitButtonPadding lodestar
  //   padding-left: 6px;
  //   padding-right: 4px;

  // Note from 2024/06/10: No clue why these are here and not part of the padding/gap settings in ToolbarButtonStyle.
  // Move there next time we refactor the code.
  // These numbers seem to assume there is an icon before the text and an icon after the text.
  if (toolbarSize === "small") {
    marginLeft = 2;
    marginRight = 0;
  } else if (toolbarSize === "medium") {
    marginLeft = 4;
    marginRight = 2;
  } else {
    // toolbarSize is large
    marginLeft = 4;
    marginRight = 2;
  }

  // Hack for now to solve ITEM-0495: Medium icon+text ToolbarButton missing right padding.
  // There are two use cases here.
  // 1. Split Button where the dropdown arrow is in its own button separate from the text button.
  //    a. Note Right Split button already has its own different padding so we don't need the full +4 here.
  // 2. Menu Button where the dropdown arrow and text are in the same button.
  if (toolbarButtonType === "ToolbarLeftSplitButton") {
    if (!hasIconAfter) {
      // increase the right margin so the overall spacing matches the spec.
      marginRight += 2;
    }
  } else if (!hasIconAfter) {
    // if there is no iconAfter in a single instance button, increase the right margin so the left/right
    //  padding appears to be the same.
    marginRight += 4;
  }
  return `
            margin-left: ${marginLeft}px;
            margin-right: ${marginRight}px;
            flex: 1 1 auto;
            ${textAlign ? `text-align: ${textAlign};` : ""}
        `;
}}
`;
exports.ToolbarButtonText = ToolbarButtonText;
//# sourceMappingURL=ToolbarButtonText.js.map